import {WidgetHelperButton} from "./widget-helper-button";
import {ObjectChangeInformation} from "../logic/object-change-information";

export class WidgetHelperButtonEvent {

    widgetHelperButton:WidgetHelperButton;
    changeInfo:ObjectChangeInformation

}